import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ApplicationStatusService {

  private isInitialised: boolean = false;

  public setIsInitialised(value: boolean) {
    this.isInitialised = value
  }

  public getIsInitialised() {
    return this.isInitialised;
  };
}
